import {
  ATTORNEY_DIRECTORY,
  ATTORNEY_PROFILE,
  CITY_PAGE,
  CONSUMER_REPORT,
  HOME_PAGE,
  LANDING_PAGE,
  LEARN_ARTICLE,
  STATE_PAGE,
} from './contentGroups';

export default {
  [HOME_PAGE]: 'contentGroup1',
  [LANDING_PAGE]: 'contentGroup2',
  [CONSUMER_REPORT]: 'contentGroup2',
  [ATTORNEY_DIRECTORY]: 'contentGroup2',
  [ATTORNEY_PROFILE]: 'contentGroup2',
  [LEARN_ARTICLE]: 'contentGroup3',
  [STATE_PAGE]: 'contentGroup4',
  [CITY_PAGE]: 'contentGroup5',
};
